const formatValue = (value) => {
    if (!value) return '0.00';
    if (isNaN(parseInt(value, 10))) return '0.00';

    const newValue = parseFloat(
        value.toString().replace(/,/g, '')
    ).toFixed(2);

    const valueParts = newValue.split('.');
    const thousantSeparator = valueParts[0]
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    return `${thousantSeparator}.${valueParts[1]}`;
}

const clearValue = (value) =>
    value.replace(/,/g, '');

export {
    formatValue,
    clearValue
};



// WEBPACK FOOTER //
// ./src/utils.js